import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, mergeProps as _mergeProps, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { "data-cy": "AuditCheckOkButton_Tooltip" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn_icon = _resolveComponent("v-btn-icon")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!

  return (_openBlock(), _createBlock(_component_v_tooltip, {
    location: "bottom",
    disabled: !_ctx.hasTooltip
  }, {
    activator: _withCtx(({ props }) => [
      _createVNode(_component_v_btn_icon, _mergeProps({ class: "align-end" }, props, {
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onAuditCheckOkButtonClick())),
        "data-cy": "AuditCheckOkButton_Button_Click"
      }), {
        default: _withCtx(() => [
          _createVNode(_component_v_icon, {
            class: "pb-1",
            color: "primary",
            size: "x-large"
          }, {
            default: _withCtx(() => _cache[1] || (_cache[1] = [
              _createTextVNode(" $check ")
            ])),
            _: 1
          })
        ]),
        _: 2
      }, 1040)
    ]),
    default: _withCtx(() => [
      _createElementVNode("span", _hoisted_1, _toDisplayString(_ctx.tooltipMessage), 1)
    ]),
    _: 1
  }, 8, ["disabled"]))
}